const appHistory = {
  id: `${performance.now()}-${Math.random() * 128}`,
}

export default appHistory
